import {useMutation} from "@tanstack/react-query";

import {renewRepresentativeContractMutationOptions} from "./renew-representative-contract.mutation-options";

export function useRenewRepresentativeContract(representativeId: string) {
  return useMutation(renewRepresentativeContractMutationOptions(representativeId));
}
